import { ErrorMetricName as error, PerformanceMetricName as performance, UserInteractionMetricName as userInteraction, } from './catalog';
var catalog = {
    error: error,
    performance: performance,
    userInteraction: userInteraction,
};
export { catalog };
